import { Button, Menu, MoreIcon, StopIcon, TransferIcon } from "melco-ui";
import { Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import {
  Drawer as DrawerType,
  MelcoModelsUserSerialNumber,
} from "melco-shared-logic";
import { useRolesContext } from "../../hooks/roles/useRolesContext";

type LicenseMoreActionButtonProps = {
  cancelLicenseDrawer: DrawerType;
  transferLicenseDrawer: DrawerType;
  license: MelcoModelsUserSerialNumber | undefined;
};

export const LicenseMoreActionButton: React.FC<
  LicenseMoreActionButtonProps
> = ({ cancelLicenseDrawer, transferLicenseDrawer, license }) => {
  const { t } = useTranslation();

  const { roles } = useRolesContext();

  /** 
     * License Status
        0-NotActivated
        1-Activated
        2-Cancelled
    */
  const MoreActions = (
    <Menu>
      {roles.VIRTUAL_SECURITY_CANCEL && license?.type !== 2 && (
        <Menu.Item
          key="more-actions-cancel"
          onClick={cancelLicenseDrawer.openDrawer}
          icon={<StopIcon />}
        >
          {t("licenses.basic.actions.cancel.button")}
        </Menu.Item>
      )}
      {roles.VIRTUAL_SECURITY_TRANSFER && license?.type == 1 && (
        <Menu.Item
          key="more-actions-transfer"
          onClick={transferLicenseDrawer.openDrawer}
          icon={<TransferIcon />}
        >
          {t("licenses.basic.actions.transfer.button")}
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <Dropdown
      overlay={MoreActions}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
      <Button
        key="license-more-actions"
        icon={<MoreIcon />}
        data-cy-id="license-more-actions"
      />
    </Dropdown>
  );
};
